import { render, staticRenderFns } from "./TestModule.vue?vue&type=template&id=413c4794&scoped=true&"
import script from "./TestModule.vue?vue&type=script&lang=js&"
export * from "./TestModule.vue?vue&type=script&lang=js&"
import style0 from "./TestModule.vue?vue&type=style&index=0&id=413c4794&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413c4794",
  null
  
)

export default component.exports